<div class="wiz-box">
  <div class="heading">{{'wizard.step-7.title' | translate}}</div>
  <div class="display-flex flex-column justify-content-center align-items-center w-100">
    <div class="icon-ok mt-5 mb-5" style="scale: 230%"></div>
    <div class="heading-2">{{'wizard.step-7.result.import-done-heading' | translate}}</div>
    <div>{{'wizard.step-7.result.import-done' | translate}}</div>
  </div>
  <div class="wiz-content">
<!--    <p class="my-2 mb-3 text-muted">{{'wizard.step-7.result.p-1' | translate}}</p>-->
    <ng-container
      *ngTemplateOutlet="template;context:{ctx:{context: 'ean', errorCount:eanErrorCount, loading}}">
    </ng-container>
    <ng-container
      *ngTemplateOutlet="template;context:{ctx:{context: 'price', errorCount:priceErrorCount, loading}}">
    </ng-container>
    <ng-container
      *ngTemplateOutlet="template;context:{ctx:{context: 'supplier', errorCount:supplierErrorCount, loading}}">
    </ng-container>
    <div *ngIf="eanErrorCount !== 0 || priceErrorCount !== 0 || supplierErrorCount !== 0"
         class="display-flex flex-column justify-content-center align-items-center w-100 mt-5 mb-3">
      <p class="text-align-center">
        {{'wizard.step-7.result.p-2' | translate}}
      </p>
      <button class="primary-btn" routerLink="/plugplay/step-7/import"><span>{{'wizard.step-7.next-import' | translate}}</span></button>
    </div>
  </div>
  <div class="wiz-footer">
    <button class="secondary-btn" routerLink="/plugplay/step-7/check"><i class="fas fa-chevron-left"></i><span>{{'wizard.step-7.btn-back' | translate}}</span></button>
    <button class="primary-btn" routerLink="/plugplay/step-8" (click)="setHighestLastStepCompleted.emit(6)"><span>{{'wizard.step-7.result.btn-continue' | translate}}</span><i class="fas fa-chevron-right"></i></button>
  </div>
</div>

<ng-template #template let-ctx="ctx">
  <div class="wiz-clarity-box">
    <div class="wiz-clarity-box-text">
      <div class="wiz-clarity-box-name">{{'wizard.step-7.'+ctx.context+'.title' | translate}}</div>
      <p>{{'wizard.step-7.'+ctx.context+'.p-1' | translate}}</p>
      <div *ngIf="ctx.loading;else result">{{'wizard.step-7.'+ctx.context+'.check' | translate}}</div>
      <ng-template #result>
        <div *ngIf="ctx.errorCount === 0; then thenBlock else elseBlock"></div>
        <ng-template #thenBlock>
          <div class="text-strong text-ok">{{'wizard.step-7.'+ctx.context+'.all-have' | translate}}</div>
        </ng-template>
        <ng-template #elseBlock>
          <div class="text-strong text-warning">{{ctx.errorCount}} {{'wizard.step-7.'+ctx.context+'.not-ok' | translate}}</div>
        </ng-template>
      </ng-template>
    </div>
    <div class="wiz-clarity-box-right">
        <span *ngIf="!ctx.loading"
              [ngClass]="{'icon-ok':ctx.errorCount===0, 'icon-warning': ctx.errorCount !==0}"></span>
      <p-progressSpinner *ngIf="ctx.loading" class="small-spinner"></p-progressSpinner>
    </div>
  </div>
</ng-template>
